/**
 * Fixed globals for the Beetronix company profile landing page.
 * Only non-translatable data lives here — every visible string is in /src/i18n.
 */

export const BASE_URL = process.env.BASE_URL || '/'

/* ── language ──────────────────────────────────────────────────────────── */

export const LANG_STORAGE_KEY = 'lang'
export const DEFAULT_LANGUAGE = 'en'
export const SUPPORTED_LANGUAGES = ['en', 'ar']
export const LANGUAGE_DIRECTIONS = { en: 'ltr', ar: 'rtl' }

/* ── the profile PDFs (served from /public so they stay downloadable) ──── */

export const PROFILE_FILES = {
	en: {
		href: `${BASE_URL}profile/Beetronix-Company-Profile-EN.pdf`,
		name: 'Beetronix-Company-Profile-EN.pdf'
	},
	ar: {
		href: `${BASE_URL}profile/Beetronix-Company-Profile-AR.pdf`,
		name: 'Beetronix-Company-Profile-AR.pdf'
	}
}

/* ── contact details, straight from the profile's last page ────────────── */

export const CONTACT_INFO = {
	phone: '+963993327101',
	phoneDisplay: '+963 99 332 7101',
	email: 'info@beetronix.com',
	website: 'www.beetronix.com',
	websiteUrl: 'https://www.beetronix.com',
	linkedin: 'beetronix',
	linkedinUrl: 'https://www.linkedin.com/company/beetronix',
	mapUrl: 'https://maps.google.com/?q=Beetronix+Aleppo+Syria',
	whatsappUrl: 'https://wa.me/963993327101'
}

/* ── page structure ───────────────────────────────────────────────────── */

export const SECTION_IDS = [
	'about',
	'global',
	'products',
	'services',
	'values',
	'signature',
	'contact'
]

export const STATS = [
	{ key: 'years', value: 13, suffix: '+' },
	{ key: 'countries', value: 15, suffix: '+' },
	{ key: 'ecosystems', value: 4, suffix: '' },
	{ key: 'support', value: 24, suffix: '/7' }
]

export const COUNTRY_KEYS = [
	'syria', 'lebanon', 'turkey', 'saudi-arabia', 'uae', 'egypt', 'libya',
	'tunisia', 'germany', 'holland', 'canada', 'guatemala', 'china', 'south-korea'
]

/**
 * The four BEE-ONE ecosystems. `moduleKeys` order matches the extracted
 * module icons (mod-<sector>-01 … -06), so the icon index follows the array.
 */
export const SECTORS = [
	{
		key: 'medical',
		logo: 'logo-octopharma.webp',
		color: '#1b4f9c',
		moduleKeys: [
			'medical-marketing', 'human-resources', 'rep-exam-system',
			'document-management', 'customized-websites', 'inventory-management'
		]
	},
	{
		key: 'commercial',
		logo: 'logo-emerald.webp',
		color: '#00a15a',
		moduleKeys: [
			'accounting-finance', 'e-commerce', 'warehouse-management',
			'crm-system', 'pos-system', 'sales-management'
		]
	},
	{
		key: 'education',
		logo: 'logo-edunix.webp',
		color: '#e8552f',
		moduleKeys: [
			'education-management', 'human-resources', 'exam-system',
			'gps-tracking', 'customized-websites', 'registration'
		]
	},
	{
		key: 'industrial',
		logo: 'logo-acacia.webp',
		color: '#0f9a56',
		moduleKeys: [
			'production-system', 'machine-maintenance', 'warehouse-management',
			'customized-websites', 'pos-system', 'sales-management'
		]
	}
]

export const PARTNER_COUNTS = {
	medical: 12,
	commercial: 27,
	education: 32,
	industrial: 15
}

export const SERVICE_KEYS = [
	'beeone-system',
	'customized-solution',
	'technical-studies',
	'strategic-consulting',
	'arbitration-expert'
]

export const VALUE_KEYS = [
	'innovation',
	'sustainability',
	'quality',
	'customer-first',
	'professionalism',
	'transparency'
]

export const SIGNATURE_KEYS = [
	'productization',
	'proven-experience',
	'tailor-made',
	'quality-reliability',
	'seamless-integration',
	'local-expertise',
	'support-24-7',
	'invest-once'
]

export const ABOUT_PARAGRAPH_COUNT = 2
export const ABOUT_CREED_COUNT = 4
